<!--
  @Description: 文章模块-收藏
  @Author: wang.y 
  @Date: 2022-02-23 
-->
<template>
  <div>
    <div class="commonlist">
      <div class="img-item" v-for="(item, index) in list" :key="item.id">
        <div class="img" @click="$parent.goDetail(4, item.id)">
          <img :src="item.logo_path | logo_show" class="logo" />
        </div>
        <div class="info">
          <div class="title over-p2" @click="$parent.goDetail(4, item.id)">{{item.title}}</div>
          <div class="summary over-p2">{{item.summary}}</div>
          <div class="dec">
            <div class="lt">
              <img :src="item.author_logo_path | logo_show" class="header-img" />
              <span class="span1">{{item.author_name}}</span>
              <span class="span1">{{item.publish_time}}</span>
            </div>
            <div class="collect_share">
              {{item.create_time}}
              <i class="iconfont collec-icon" @click="handleCancel('4', item.id, cancelCollectCb, index)" title="取消收藏">&#xe66f;</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spin v-if="loading" class="list-loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="more-btn" v-if="more && !loading">
      <div @click="handleMore('4')">加载更多</div>
    </div>
    <default-list v-if="!list.length && !loading">
      <template slot="p">
        <p>您目前没有收藏任何文章，不如去随便逛逛<br />看看有什么内容值得收藏起来，反复品读</p>
        <router-link :to="{ name: 'Main' }">去看看</router-link>
      </template>
    </default-list>
  </div>
</template>
<script>
import DefaultList from './DefaultList'
import { collect_list } from 'js/collect_list'
export default {
  mixins: [collect_list],
  components: {
    DefaultList
  },
  created() {
    this.userFavorite('4')
  },
  mounted() { },
  data() {
    return {

    }
  },
  computed: {},
  methods: {

  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common2.0.stylus'
</style>